/* File: detail.js
 ------------------
 This file does calculations and api calls for detail.html template.
 Important assumptions are noted here for reference.
 * Weight field in template is assumed that
  1 - it would be only 8 char long only.
  2 - it would not be null
  3 - 8th char should not be zero.

  if all 3 conditions are met then only weight element will be shown on consumer app. This validation is
  not done at the backoffice app.
*/



import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import upArrow from './../../../images/up.png';
import downArrow from './../../../images/up_menu.png';
import FBLogo from './../../../images/fb-logo.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import higlightedmarkerIcon from './../../../images/wbu-pointer.png';
import markerIcon from './../../../images/wbu-map-pointer.png';
import template from './detail.html';
import searchIcon from './../../../images/search.png';
import oopsImage from './../../../images/oops-page.png';
import leftArrow from './../../../images/hamburger.png';
import dscCardDefault from './../../../images/DSC-Card.png';
import dscCardMobileDefault from './../../../images/product-promo-mobile.png';
import alertIcon from './../../../images/alert.png';
import tempUnavailable from './../../../images/tempunavailable_L.png';
import powercss from './../../../styles/power.css';
import addedtoCartTick from './../../../images/red_tick.png';
import savedTick from './../../../images/shipping-tick.png';

@Component({
  controllerAs: 'productDetail',
  template
})

export default class ProductDetail {
  static $inject = [
    '$rootScope',
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    'authService',
    'orderService',
    'orderActions',
    'spinnerService',
    'toaster',
    '$uibModal',
    '$timeout',
    'ngMeta',
    '$location',
    '$window',
    'APP',
    '$sce'
  ];

  constructor($rootScope, $scope, $ngRedux, $state, $stateParams, $auth,
    $order, orderActions, $spinner, toaster, $uibModal, $timeout, ngMeta, $location, $window, APP, $sce) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.ngMeta = ngMeta;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$auth = $auth;
    this.$order = $order;
    this.dscCardMobileDefault = dscCardMobileDefault;
    this.$rootScope = $rootScope;
    this.toaster = toaster;
    this.FBLogo = FBLogo;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.alertIcon = alertIcon;
    this.tempUnavailable = tempUnavailable;
    this.houseIcon = houseIcon;
    this.$uibModal = $uibModal;
    this.subCategoryName = '';
    this.storeName = '';
    this.searchIcon = searchIcon;
    this.oopsImage = oopsImage;
    this.productNotFound = false;
    this.isDeliveryError = false;
    this.dscCardDefault = dscCardDefault;
    this.dscAltTag = 'DSC Offer';
    this.markerIcon = markerIcon;
    this.$sce=$sce;
    this.isMiscelleneousCategory = 4;
    this.canShowQAhr=false;
    this.cylinder = 'Cylinder';
    this.browserUrl = 'shop';
    this.showDescription = true;
    this.showSpecifications = false;
    this.showWarranty = false;
    this.showMaterials = false;
    this.showIngredients = false;
    this.addedtoCartTick = addedtoCartTick;
    this.isAddToCartPopUpShown = false;
    this.customSpecification = "";
    this.isDscClickable = false;
    this.savedTick = savedTick;
    this.APP = APP;
    this.link={};
    this.currentLink = {"hasFetched": false, "hasLinkToShow": false};
    this.hasLinkToShow=false;
    this.constructedLink = null;
    this.OutOfStockRemainderText = {
      'new' : 'Reminder set to notify when item is in-stock',
      'exist' : 'Reminder already set to notify when item is in-stock'
    };

    this.quantityAction = {
      "AddingQuantity" : "AddingQuantity",
      "ReducingQuantity" : "ReducingQuantity"
    };

    this.userAction = {
      "ViewCart" : "ViewCart",
      "ContinueShopping" : "ContinueShopping",
      "NoAction" : "NoAction"
    };

    this.productImageStyle = {
      'text-align': 'center',
      'padding-left': '15px'
    };
    // this.productDescStyle = {
    //   'padding-left': '21px',
    //   'padding-right': '6px'
    // };
    this.marleft20 = {
      'margin-left': '20px'
    };
    this.productDescStyle = {
      'right' : '40px'
      };
    this.noPadding = {
      'padding': '0px'
    };
    this.Padding = {
      'padding-right': '24px',
      'padding-left': '24px'
    };
    this.Padding_Mob = {
      'padding-right': '24px',
      'padding-left': '24px'
      // 'display': 'inline-grid'
    };
    this.higlightedmarkerIcon = higlightedmarkerIcon;
    this.leftArrow = leftArrow;
    this.selectedItem = {};
    this.isItemAdded = false;
    this.imageList = [];
    this.videoList = [];
    this.imgVideoList = [];
    this.imageListArr = [];
    this.imageListZoom = [];
    this.videoListZoom = [];
    this.imgVideoIpadList = [];
    this.referralProducts = [];
    this.slideIndex = 1;
    this.slideIndexZoom = 1;
    this.slideIndexIpad = 1;
    this.selectedImgZoom = '';
    this.upArrow = upArrow;
    this.downArrow = downArrow;
    this.isShowImage = false;
    this.isShowVideo = false;
    this.currentImagePosition = 0;
    this.currentImagePositionHeight = 0;
    this.multiImageViewPortSlideSize = 3;
    if(window && window.location) {
      this.domain = window.location.origin;
    }

    console.log("this.$stateParams.productId -------", this.$stateParams.productId);
    console.log("this.$stateParams.reminderId -------", this.$stateParams.reminderId);

    if(this.$stateParams.reminderId) {
      this.$order.remainderUsed(this.$stateParams.reminderId);
    }

    var forSeoSite = $location.path().split(/\//g);
    if(forSeoSite.length>0 && forSeoSite[1]){
      if(forSeoSite[1] == this.browserUrl){
        this.isSeoSite = true;
      } else {
        this.isSeoSite = false;
      }
    }

    this.$order.getStoreFeatures();

    this.guestCart = this.$auth.getGuestCart();
    this.isLoggedIn = this.$auth.isLoggedIn();
    // console.log(isLoggedIn);
    this.checkForGuestCart();
    $window.scrollTo(0, 0);
    this.$window = $window;
    
    this.pwrProduct = {};
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + this.APP.ORDER.ORDER_URL.browseUrl + '/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.$stateParams.storeName +'/' + this.$stateParams.categoryId +'/' + this.$stateParams.subCategoryId+'/' + this.$stateParams.productId;
    }
    else {
      this.canUrl = this.$location.$$absUrl;
    }
    this.ngMeta.setTag('canUrl', this.canUrl);

    this.forSubscription = this.$stateParams.forSubscription;
    $ngRedux.dispatch(orderActions.setProductDetail({}));
    $spinner.show('appSpinner');
    this.$spinner = $spinner;
    this.$order = $order;
    this.$stateParams = $stateParams;
    this.orderActions = orderActions;
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.subCategoryName = '';
    this.categoryName = '';
    this.storeName = '';
    this.productLoadCount = 0;
    if ((this.$auth.isLoggedIn() || this.$auth.isGuestLogin()) && this.$stateParams) {
      if (this.$auth.isLoggedIn()) {
        $auth.getUserProfile().then(() => {
          if(this.isDscMember()){
            this.isDscClickable = false;
            this.getDSCDetails(true);
          } else {
            this.isDscClickable = true;
            this.getDSCDetails(false);
          }
          this.loadProducts();
          $order.getCartDetail().then(() => {});

        });
      }
      else {
        this.isDscClickable = true;
        this.getDSCDetails(false);
        $timeout(() => {
          this.loadProducts();
        }, 300);
      }
    } else {
      this.getDSCDetails(false);
      this.isDscClickable = true;
    }

    

    var listener1 = $rootScope.$on('onLoginSuccess', () => { this.checkForGuestCart(); });
    var listener2 = $rootScope.$on('onGuestLogin', () => this.loadProducts());
    var listener3 = $rootScope.$on('storeSelected', () => { this.confirmChangeStore($rootScope.selectedStoreId, $rootScope.selectedStore); });


    $scope.$on('$destroy', () => {
      disconnect();
      listener1();
      listener2();
      listener3();
    });

    $scope.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    };
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      detail: state.order.productDetail,
      // referralProducts: state.order.referralProducts,
      cartDetail: state.order.cartDetail,
      storeLocation: state.auth.storeDetail,
      storeFeatures: state.order.storeFeatures
    };
  }

  loadProducts() {
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      this.storeName = this.$stateParams.storeName;
    }
    else {
      if (this.profile.store && this.profile.store.storeName) {
        this.storeName = this.profile.store.storeURLName;
      } else {
        this.storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    let categoryNameResponse = this.$order.getCateoryNamebyId(this.$stateParams.categoryId);
    categoryNameResponse.then(success => {

      this.categoryName = success.data;
    });
    let subCategoryNameResponse = this.$order.getSubCateoryNamebyId(this.$stateParams.subCategoryId);
    subCategoryNameResponse.then(success => {

      this.subCategoryName = success.data;
    });
    let categoryId = this.$stateParams.categoryId;
    // console.log('lthis.$stateParams.subCategoryId;',this.$stateParams.subCategoryId);
    let subCategoryId = this.$stateParams.subCategoryId;
    let productPrettyId = this.$stateParams.productId;
    let itemGroupNumber = this.$stateParams.itemGroupNumber;
    this.selectedItem = {};
    let $ctrl = this;
    // this.$order.getProductsByGroupNumber(categoryId, subCategoryId,itemGroupNumber)
    // this.$order.getProducts(categoryId, subCategoryId)
    this.$order.getProductOfSameGroupByPrettyUrl(subCategoryId, productPrettyId)
      .then(success => {
        this.productLoadCount++;
        if (success.data && success.data[0]) {
        
          let productAvailable = success.data.filter(product => {
            let idArray = product.itemList.filter(item => {
                item.masterProduct.prettyUrl == $ctrl.$stateParams.productId;
                this.link[item.masterProduct.id] = {};
                this.link[item.masterProduct.id].hasFetched = false;
                this.link[item.masterProduct.id].hasLinkToShow = false;
              }
            );

            if(idArray.length==0){
              if(success.data[0].itemList.length>0) {
                idArray = success.data[0].itemList;
              }
            }

            if (idArray.length > 0) {
              this.imageList = [];
              this.videoList = [];
              this.imgVideoList = [];
              this.imgVideoIpadList = [];
              this.imageListZoom = [];
              this.videoListZoom = [];
              product.itemList.forEach(item => {
                console.log('item.masterProduct.id', item.masterProduct.id);
                this.getMultipleImage(item.masterProduct);
              });
              this.ngMeta.setTitle(idArray[0].masterProduct.itemName);
              this.ngMeta.setTag('description', idArray[0].masterProduct.description ? idArray[0].masterProduct.description : 'Product Page description');
              this.ngMeta.setTag('image', idArray[0].masterProduct.smallImageUrl);
              this.ngMeta.setTag('alt', idArray[0].masterProduct.alt ? idArray[0].masterProduct.alt : 'Product Image');

              // console.log("IdArray ::::", idArray[0].masterProduct.masterCode);
              // this.getMultipleImage(idArray[0].masterProduct.id, true);
              
              setTimeout(function(){
                // $ctrl.$order.getReferralProducts(idArray[0].masterProduct.masterCode);
                $ctrl.referralProducts = [];
                $ctrl.$order.getReferrals(idArray[0].masterProduct.masterCode).then(success => {
                  if (success.data && success.data) {
                    $ctrl.referralProducts = success.data;
                  }
                });
                document.getElementById('headline').classList.remove('hide');
                document.getElementById('headlinefooter').classList.remove('hide');
                if(document.getElementById('dotimage')){
                  document.getElementById('dotimage').classList.remove('hide');
                }
               }, 1000);
            }
            return idArray.length ? true : false;
          }).length;
          // console.log('success data', success.data);
          console.log('productAvailable', productAvailable);
          // console.log('paramid', this.$stateParams.productId);
          if (success.data[0] === null) {
            this.productNotFound = true;
            // this.toaster.pop('success', 'You are trying to access wrong Sub-Category.');
            // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
          }
          if (!productAvailable) {
            this.productNotFound = true;
            // this.toaster.pop('success', 'Product is not available');
            // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
          }
          else {

            this.productNotFound = false;
          }
          if (this.$stateParams.productId) {
            // if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
            //   this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '');
            // } 
            // else{
            //   this.canUrl = '';
            // }
            // console.log("Shop Url :",  this.APP.ORDER.ORDER_URL.browseUrl);
            // console.log('STORENAME :', this.$stateParams.storeName);
            // this.ngMeta.setTag('canUrl',this.canUrl);
            let productDetail = success.data.filter(item => {

              if (item.itemList.filter(itemVariety =>
                itemVariety.masterProduct.prettyUrl === this.$stateParams.productId)[0]) {

                /* ngMeta.setTitle(item.itemList[0].name);
                 ngMeta.setTag('description',item.itemList[0].briefDescription);
                 ngMeta.setTag('url','https://order.wbu.com/store/order/category/indianapolis/'+this.$stateParams.categoryId+'/sub-category/'+$stateParams.subCategoryId+'/product/'+$stateParams.productId+'/detail');
                 ngMeta.setTag('image',item.itemList[0].largeImageUrl);
                 ngMeta.setTag('alt',item.itemList[0].name);*/
              }
              let productFound = item.itemList.filter(itemVariety =>
                itemVariety.masterProduct.prettyUrl === this.$stateParams.productId)[0];
                // From SEO Site, there may be chances that selected product weight might
                // not available in store. So, since we are fetching based on groups
                // we can show the available item of different weight if product not found.
              if(productFound!=null) {
                return productFound;
              } else {
                  return success.data[0].itemList[0];
              }
            })[0];
            console.log("productDetail--", productDetail);
            if (productDetail) {
              console.log("this.seosite : ", this.isSeoSite);
              if (!this.isSeoSite && productDetail.itemList && productDetail.itemList.length && !productDetail.itemList[0].price && this.productLoadCount < 5) {
                this.loadProducts();
              }

              this.$window.document.title = productDetail.itemList[0].masterProduct.title ? (productDetail.itemList[0].masterProduct.title + ' | Wild Birds Unlimited') : this.APP.ORDER.ORDER_URL.siteTitle;

              let weight = 0;
              let itemToSelect = productDetail.itemList[0];
              this.currencyType = (productDetail.itemList[0].store && productDetail.itemList[0].store.country.countryCode) == "US" ? 'USD' : 'CAD';
              if (itemToSelect.name.indexOf(this.cylinder) === -1) {
                if (itemToSelect.weight) {
                  weight = productDetail.itemList[0].weight;
                  for (var i = 0; i < productDetail.itemList.length; i++) {
                    if (productDetail.itemList[i].weight > weight) {
                      itemToSelect = productDetail.itemList[i];
                      weight = productDetail.itemList[i].weight;
                    }
                  }
                }
              } else {
                if (itemToSelect.weight) {
                  weight = productDetail.itemList[0].weight;
                  for (var j = 0; j < productDetail.itemList.length; j++) {
                    if (productDetail.itemList[j].weight < weight) {
                      itemToSelect = productDetail.itemList[j];
                      weight = productDetail.itemList[j].weight;
                    }
                  }
                }
              }

              // this.setDimension(itemToSelect);

              this.selectedItem = itemToSelect;
              if(this.selectedItem!=null) {
                this.currentItemGroupNumber = this.selectedItem.masterProduct.itemGroupNumber;
                this.getLinks(this.selectedItem);
              }
              if(this.selectedItem.isOutOfStock) {
                if (this.profile.email){
                  this.emailToRemainder = this.profile.email;
                }
                // May enhance the below code to save cache and show the remainder set already.
                // THe below codes works for guest but not for logged in user.
                // let outOfStockRemainders = sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS') ? JSON.parse(sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS')) : null;
                // if(outOfStockRemainders!=null && outOfStockRemainders[this.selectedItem.id]){
                //   this.isRemainderSetAlready = true;
                //   this.outOfStockRemainderText = this.OutOfStockRemainderText.exist;
                // }
              }
              
              // Power review updates for product detail paged
              var forSeoSite = $ctrl.$location.path().split(/\//g);
              var replacePattern = '';
              if(forSeoSite.length>0 && forSeoSite[1]){
                replacePattern = new RegExp(forSeoSite[1],"gi");
              }
              console.log("replacePattern string for store in wrapper url for power reivew : ",replacePattern);
              var urlToString = $ctrl.$location.absUrl().replace(replacePattern,this.APP.ORDER.ORDER_URL.browseUrl);
              this.pwrProduct.api_key = this.APP.AUTH.AUTH_URL.pwr.api_key;
              this.pwrProduct.locale = this.APP.AUTH.AUTH_URL.pwr.locale;
              this.pwrProduct.merchant_group_id = this.APP.AUTH.AUTH_URL.pwr.merchant_group_id;
              this.pwrProduct.merchant_id = this.APP.AUTH.AUTH_URL.pwr.merchant_id;
              this.pwrProduct.style_sheet = powercss;
              this.pwrProduct.review_wrapper_url= urlToString+"/write-a-review?";
              // this.pwrProduct.on_render = function(config, data) {
              //   if(config!=null){
              //     if(config.component=='QuestionSnippet'){
              //       if(data!=null && data.question_count<1){
              //         var node = document.querySelectorAll('[title="Questions & Answers"]');
              //         for (var index=0; index < node.length; index++) {
              //           if(index==0){
              //             node[index].style.display='none';
              //           }
              //         }
              //       }
              //     }
              //   }
              // };
              this.pwrProduct.on_render = function(config, data) {
                if(config!=null){
                  // console.log("config : ",config);
                  // console.log("data : ",data);
                  if(config.component=='QuestionSnippet'){
                    if(data!=null && data.question_count<1){
                      var nodelist = document.getElementsByClassName("pr-qa-display");
                      // console.log("nodelist : ", nodelist[0]);
                      nodelist[0].style.display='none';
                      $ctrl.canShowQAhr=false;
                    } else {
                      $ctrl.canShowQAhr=true;
                    }
                    // console.log("this.canShowQAhr : ",$ctrl.canShowQAhr);
                  }
                  if(!$ctrl.isNotMobile()){
                    var prreview_list = document.getElementsByClassName("pr-review"); 
                    for(var i=0; i<prreview_list.length; i++){
                      prreview_list[i].style.padding = '15px';
                      var spacebtwreviews = prreview_list[i].querySelector('.pr-rd-footer');
                      // console.log("spacebtwreviews :- ",spacebtwreviews);
                      if(spacebtwreviews!=null){
                        $ctrl.removeClass(spacebtwreviews, "pr-rd-footer");
                        $ctrl.addClass(spacebtwreviews, "pwr-pr-rd-footer");
                      }
                    }
                    var askQuestionButton = document.getElementById("pr-question-form-link");
                    // console.log("askQuestionButton : ", askQuestionButton);
                    if (askQuestionButton!=null ) {
                      askQuestionButton.style.padding='12px';
                      if(askQuestionButton.hasChildNodes()){
                        askQuestionButton.firstElementChild.style.marginTop='12px';
                        askQuestionButton.firstElementChild.style.color='white !important';
                        if(askQuestionButton.childNodes.length>1){
                          // "pr-qa-display-text"
                          $ctrl.removeClass(askQuestionButton.childNodes[1], "pr-qa-display-text");
                          $ctrl.addClass(askQuestionButton.childNodes[1], "pwr-ask-question-text");
                          console.log("askQuestionButton update : ", askQuestionButton);
                        }
                      }
                    } 
                  }
                }
              };
              if(productDetail.itemList && productDetail.itemList.length>0){
                var desc = "";
                if(this.selectedItem.briefDescription && this.selectedItem.briefDescription!=null){
                  desc = this.selectedItem.briefDescription;
                } else {
                  desc = this.selectedItem.name;
                }
                this.pwrProduct.product = {
                  'name' : this.selectedItem.name,
                  'url' : this.$location.absUrl(),
                  'image_url' : this.selectedItem.masterProduct.smallImageUrl,
                  'description' : desc,
                  'category_name' : this.categoryName.prettyUrl,
                  'manufacturer_id' : '',
                  'upc' : '',
                  'brand_name' : 'Wild Birds Unlimited',
                  'price' : this.selectedItem.price,
                  'in_stock' : true,
                  'asin' : ''
                };
                $ctrl.pwrProduct.page_id = productDetail.itemList[0].masterProduct.masterCode.substring(0, 7);
                if(productDetail.itemList.length>0){
                  $ctrl.pwrProduct.product.variants = [];
                  productDetail.itemList.forEach(item => {
                    if(item.weight){
                      var itemDesc = "";
                      if( item.briefDescription && item.briefDescription!=null){
                        itemDesc = item.briefDescription;
                      } else {
                        itemDesc = item.masterProduct.itemName;
                      }
                      $ctrl.pwrProduct.product.variants.push({
                        'name' : item.masterProduct.itemName,
                        'manufacturer_id' : '',
                        'page_id_variant':item.weight,
                        'upc':'',
                        'description' : itemDesc
                      });
                    }
                    });
                }
              }
              this.pwrProduct.components = {
                'ReviewDisplay' : 'pr-reviewdisplay',
                'ReviewSnippet': 'pr-reviewsnippet',
                'QuestionSnippet': 'pr-questionsnippet',
                'QuestionDisplay': 'pr-questiondisplay'
              };
              console.log("this.pwrProduct",this.pwrProduct); 
              window.pwr = window.pwr || function () {
                (window.pwr.q = window.pwr.q || []).push(arguments); 
              };
              console.log("window.pwr : ", window.pwr);
              setTimeout(() => {
                window.pwr("render", this.pwrProduct);
               }, 1000);
              this.$ngRedux.dispatch(this.orderActions.setProductDetail(productDetail));
            }
            if (!productDetail) {
              this.productNotFound = true;
              // this.toaster.pop('success', 'You are trying to access wrong Product Details.');
              // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
              // return;
            }
          }
        }
        else {
          this.productNotFound = true;
        }
      })
      .catch(err => {
         this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => 
      {
        this.$spinner.hide('appSpinner');
        this.sendDataToInteractionStudio(this.detail);
      }
      );
  }

  getLinks(item) {
    let masterId = item.masterProduct.id;
    let tempLink = this.link[masterId];
    if(this.currentItemGroupNumber==item.masterProduct.itemGroupNumber) {
      if(tempLink!=null && !tempLink.hasFetched) {
        this.$order.getLinksByMasterId(masterId).then(success => {
          if(success.data && success.data.link) {
            tempLink.hasLinkToShow = true;
            tempLink.constructedLink = success.data.link;
            tempLink.linkName = success.data.linkName;
            tempLink.display_in = success.data.display_in;
          } else {
            tempLink.hasLinkToShow=false;
          }
          tempLink.hasFetched = true;
          this.currentLink = tempLink;
          this.link[masterId] = tempLink;
        })
        .catch(error => {
          tempLink.hasFetched = true;
          tempLink.hasLinkToShow=false;
          this.currentLink = tempLink;
          this.link[masterId] = tempLink;
        });
      } else {
        this.currentLink = this.link[masterId];
      }
      console.log("this.link----",this.link);
    } else {
      this.currentLink = {"hasFetched": false, "hasLinkToShow": false};
    }
  }

  sendDataToInteractionStudio(productInfo) {
    try {
      console.log("Inside finally : ",productInfo);
      if(this.productNotFound){
        this.$order.getProductByPrettyUrl(this.$stateParams.categoryId, this.$stateParams.subCategoryId, this.$stateParams.productId).then(
          success => {
            if(success.data!=null){
              productInfo = success.data[0];
              console.log("ProductInfo :  ",productInfo);
              if(productInfo!=null && productInfo.itemList!=null && productInfo.itemList.length>0 && productInfo.itemList[0].id!=null){
                productInfo.itemList[0].isActive = false;
                console.log("Sending inactive item info to interaction studio: ",productInfo);
                this.$window.dataLayer = this.$window.dataLayer || [];
                this.$window.dataLayer.push(productInfo);
              }
            }
          });
      } else {
        this.$window.dataLayer = this.$window.dataLayer || [];
        this.$window.dataLayer.push(productInfo);
      }
  } catch (e) {
    console.log("Error : ",e);
  }
}

hasClass(ele, cls) {
    return ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}
addClass(ele, cls) {
    if (!this.hasClass(ele, cls)) ele.className += " " + cls;
}
removeClass(ele, cls) {
    if (this.hasClass(ele, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        ele.className = ele.className.replace(reg, ' ');
    }
}
replaceClass(ele, oldClass, newClass){
    if(this.hasClass(ele, oldClass)){
      this.removeClass(ele, oldClass);
        this.addClass(ele, newClass);
    }
    return;
}
toggleClass(ele, cls1, cls2){
    if(this.hasClass(ele, cls1)){
      this.replaceClass(ele, cls1, cls2);
    }else if(this.hasClass(ele, cls2)){
      this.replaceClass(ele, cls2, cls1);
    }else{
      this.addClass(ele, cls1);
    }
  }

  fbshare() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    try {
      if (storeName) {
        // this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '')+'/fb/'+ storeName + '/category/'+this.$stateParams.categoryId+'/sub-category/'+this.$stateParams.subCategoryId+'/product/'+this.$stateParams.productId+'/details';

        this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/fb/' + storeName + '/category/' + this.$stateParams.categoryId + '/sub-category/' + this.$stateParams.subCategoryId + '/product/' + this.$stateParams.productId + '/details';
        // this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + storeName + '/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
        // this.shareURL = this.shareURL.replace("http://localhost:9000", 'qa-order.wbu.com');

      }
      else {
        this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/fb/category/' + this.$stateParams.categoryId + '/sub-category/' + this.$stateParams.subCategoryId + '/product/' + this.$stateParams.productId + '/details';
        // this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/shop/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
        // this.shareURL = this.shareURL.replace("http://localhost:9000", 'qa-order.wbu.com');
      }
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + String(this.shareURL), 'pop', 'width=600, height=400, scrollbars=no');
    } catch (err) {
      // console.log(err);
    }
  }

  openLoginPopup() {
    this.$rootScope.$emit('guestLoginConfirmed');
  }

  addItemToCart(form) {

    if (form.$invalid) {
      return;
    }
    if (this.$auth.isGuestLogin()) {
      this.disableAddToCart = true;
      this.isDeliveryError = '';
      // Validating instore and Delivery only items in cart
      if (!this.deliveryTypeValidation()) {
        return;
      }
      if (this.storeLocation && !this.storeLocation.hasGuestCheckout) {
        var $ctrl = this;
        this.$uibModal.open({
          size: 'sm',
          template: '<div class="modal-body p-1-1 login_redirect_modal" id="modal-body" >You have to login/register to  add this item to cart<hr>' +
            '<h6><b><center>Do you want to continue?</center></b></h6>' +
            '</div>' +
            '<div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >' +
            '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()" >Cancel</button>' +
            '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" ">OK</button>' +
            '</div>',
          controller: ['$scope', '$uibModalInstance', 'authService', '$cookies', '$rootScope', '$timeout',
            function ($scope, $uibModalInstance, $auth, $cookies, $rootScope, $timeout) {
              $scope.ok = () => {
                $uibModalInstance.close();
  
                $rootScope.$emit('guestLoginConfirmed');
  
              };
              $scope.cancel = () => {
                try {
                  sessionStorage.removeItem('guestCart');
                }
                catch (e) {
                  $cookies.remove('guestCart');
                }
                $uibModalInstance.close();
              };
            }
          ],
          resolve: {
            id: function () {
              return $ctrl.id;
            }
          }
        });
        this.disableAddToCart = false;
        this.isDeliveryError = '';
        return;
      }

      let cartList = this.$auth.getGuestCart();
      if (cartList && cartList.length) {
        let index = cartList.findIndex(data => data.itemId === this.selectedItem.id);
        if (~index) {
          this.quantityToBeAdded = cartList[index].quantity + this.quantity;
        } else {
          this.quantityToBeAdded = this.quantity;
        }
      } else {
        this.quantityToBeAdded = this.quantity;
      }

      let cart = null;
      cart = {
        'quantity': this.quantity,
        'itemId': this.selectedItem.id,
        'categoryId': this.selectedItem.masterProduct.category.id,
        'subCategoryId': this.selectedItem.masterProduct.subCategories[0].id,
        'masterProductId': this.selectedItem.masterProduct.id,
        'deliveryType': this.selectedItem.deliveryType
      };
      this.isItemAdded = true;
      this.$auth.addtoGuestCart(cart);
      if (this.isNotMobile()) {
        this.showAddtoCartpopup();
      } else {
        this.showAddtoCartMobilepopup();
      }
      // this.toaster.pop('success', 'Item added to cart');
    } else {
      var item;
      item = {
        'itemId': this.selectedItem.id,
        'subCategoryId': this.selectedItem.masterProduct.subCategories[0].id
      };
      this.addToCart(this.quantity, item);
    }
  }

  addToCart(quantity, item) {
    this.disableAddToCart = true;
    this.isDeliveryError = '';
    // Validating instore and Delivery only items in cart
    if (!this.deliveryTypeValidation()) {
      return;
    }

    this.$order.addItemToCart(quantity, item.itemId, item.subCategoryId)
      .then(
        success => {
          this.isItemAdded = true;
          // this.toaster.pop('success', 'Item added to cart');
          this.$auth.getUserProfile();
          this.quantityToBeAdded = success.data.itemsAddedToCart;
          if (this.isNotMobile()) {
              this.showAddtoCartpopup();
            } else {
              this.showAddtoCartMobilepopup();
            }
        },
        error => {
          if (error.data.errorCode == 692) {
            this.toaster.pop('success', error.data.message);
          }
          else {
            this.toaster.pop('success', 'Item already exists in cart. Click on cart icon on top right.');
          }
        }
      )
      .finally(() => {
        this.disableAddToCart = false;
        if (this.$auth.getGuestCart()) {
          this.$auth.removeGuestCart();
        }
      }
      );
  }
  buyNow(form) {
    if (form.$invalid) {
      return;
    }
    this.$order.addItemToCart(this.quantity, this.selectedItem.id)
      .finally(() => this.$state.go('cart'));
  }

  selectWeight(item) {
    this.showImagelist(item.masterProduct.id);
    this.getLinks(item);
    // this.setDimension(item);
    this.selectedItem = item;
    this.isItemAdded = false;
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  masterCodeChecker(item) {
    return item.masterProduct.masterCode &&
      (item.masterProduct.masterCode.length === 8 || item.masterProduct.masterCode.length === 9)  &&
      item.masterProduct.masterCode[7] !== '0' &&
      item.weight !== null;
  }
  addItemToSubscription(form) {
    if (form.$invalid) {
      return;
    }
    // console.log(this.selectedItem);
    this.$auth.addToSubscriptionCart(this.selectedItem, this.quantity);
    var subScribedInfo = this.$auth.getSubscribedInfo();
    this.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });


  }
  goToSubscriptionDetail() {
    var subScribedInfo = this.$auth.getSubscribedInfo();
    if (subScribedInfo) {
      this.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });
    }
  }

  checkForGuestCart() {
    var guestCart = this.$auth.getGuestCart();
    // console.log('Guest Cart ', guestCart);
    // console.log('gc',guestCart);
    if (guestCart && this.$auth.isLoggedIn()) {
      this.addToCart(guestCart.quantity, guestCart);
      this.$auth.doGuestLogout();
    }
  }

  canUserJoin() {
    return (!(this.isDscMember() || this.isDscButExpired()));
  }

  goToSavingsClub() {
    this.$state.go('savings-club', { 'storeName': this.$auth.getGuestStoreDetail().storeName });
  }
  chooseStore() {
    // console.log('store');
  }

  confirmChangeStore(storeId, store) {
    var $ctrl;
    $ctrl = this;
    $ctrl.storeId = storeId;
    $ctrl.store = store;
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
       
        '<div class="password-container margin-ten">'+
        '<input class="form-control" type="password" id="passwordIdDetail" ng-model="password" placeholder="Enter Password">'+
        `<i class="far fa-eye-slash" ng-click="togglePassword('passwordIdDetail','togglePasswordDetail')" id="togglePasswordDetail"
                style="cursor: pointer;"></i></div>`+

        '<h5 class="font-weight-bold">Please enter your password to confirm the changing of your store</h5>' +
        '<p class="font-weight-bold" style="font-size:smaller">Please Note: You are changing your active home store. All WBU stores are locally owned and operated, and Daily Savings Club memberships are only valid at the store where purchased.  You may purchase a new DSC membership at your new home store. Club discounts, points balance, and Bird Bucks will be displayed for your active store if applicable. You may switch back to your original home store at any time and all eligible points, discounts, and Bird Bucks will be available.</p>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-disabled="!password" ng-click="ok()">OK</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Go Back</button>' +
        '</div>',
      controller: ['$scope', '$uibModalInstance', 'authService', '$stateParams', '$window',
        function ($scope, $uibModalInstance, $auth, $stateParams, $window) {

          $scope.togglePassword = (passwordId,toggleId) => {
            $ctrl.$auth.togglePassword(passwordId,toggleId);
          };

          $scope.ok = () => {
            // console.log($scope.password,  $ctrl.storeId);

            var data = {
              "newStoreId": $ctrl.storeId,
              "password": $scope.password

            };
            $auth.changeStore(data).then(data => {
              // console.log(data);
              if (data.status == 200) {
                $ctrl.toaster.pop('success', data.statusText);
                $ctrl.$timeout(() => {
                  $stateParams.storeName = $ctrl.store;
                  $window.location.href = '/' + $stateParams.storeName + '/' +
                    $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
                  // location.reload(); 
                }, 1500);
              }
              else {
                $ctrl.toaster.pop('success', data.statusText);
              }
              // 
            }).catch(err => {
              $ctrl.toaster.pop('success', err.data.message);

            });


            $uibModalInstance.close();
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ]
    });
  }

  showLoginPopUp() {
    let msg = 'Text';
    var $ctrl;
    $ctrl = this;
    $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
    $ctrl.markerIcon = this.markerIcon;
    this.$uibModal.open({
      size: 'lg',
      template:
        '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' +
        '<div class="row">' +
        '<div class="col-md-3 p-l-0 p-r-0">' +
        '<div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div style="padding: 0;">' +
        '<form class="input-group" style="text-align: center;padding: 3px;">' +
        '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' +
        '<span class="input-group-btn"  >' +
        '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' +
        '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' +
        '</button>' +
        '</span>' +
        '</form>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<br/><div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' +
        ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' +
        '<div  class="row store-nm-div">' +
        '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' +
        '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' +
        '</div> ' +
        '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' +
        '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' +
        '<span  class="search-span">Shop Now</span>' +
        '</button>' +
        '</div>' +
        '</div>' +

        '</div> </div>' +
        '<div class="col-md-12 p-r-0 p-l-0 closest-div">' +
        '<div class="col-md-12 p-r-0 p-l-0">' +
        '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' +
        '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' +

        '</div>' +
        '</div>' +
        '</div>' +


        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' +
        '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' +
        '<info-window id="storeInfo" max-width="200">' +
        '<div ng-non-bindable="">' +
        '<div class="scrollFix">' +
        '<div class="row">' +
        '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" > {{storeIndex}}) {{storeObj.city}}' +
        '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' +
        '</div>' +
        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
        //  '<div class="col-xs-12">'+
        //    '<div class="m-b-0">'+
        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
        //    '<span>{{storeObj.addressLine1}}<br />'+
        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
        //    '</div>'+
        //  '</div>'+
        '</div>' +
        '</div>' +
        '</div>' +
        '</info-window>' +
        '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' +
        '</map>' +
        '</div>',
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap',
        function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
          this.$state = $state;
          $scope.selectedStoreClass = "selectedStore";
          $scope.notSelectedClass = "";
          $scope.lat = '37.274053';
          $scope.long = '-103.535156';
          $scope.zoom = 4;
          $scope.count = 5;
          $scope.noStoresFound = false;
          $scope.stores = [];
          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
          $scope.markerIcon = $ctrl.markerIcon;
          $scope.notMoreThanone = 0;
          NgMap.getMap()
            .then(map => {
              // console.log('map', map);
              $scope.map = map;
            });
          $scope.formatMobileNum = (num, format) => {

            var unFormattedNum = num;
            var position1 = 0;
            var position2 = 4;
            var position3 = 9;
            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
            return FormattedNum;
          };
          $scope.showStoreInfo = (e, index, storeObj) => {
            $scope.changeStyle();
            $scope.selectedStore = storeObj.storeURLName;
            $scope.storeIndex = index + 1;
            // console.log('storeObj', storeObj);
            $scope.storeObj = storeObj;
            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
          };
          $scope.ok = () => {
            //  $uibModalInstance.close();
            $scope.count = 5;
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": 5

            };
            if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
              data.showRedirectStores = true;
            }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              $scope.lat = $scope.stores[0].lat;
              $scope.long = $scope.stores[0].lng;
              $scope.zoom = 4;
              $scope.noStoresFound = false;
              // console.log(success.data);
              if ($scope.stores.length == 0) {
                $scope.noStoresFound = true;
              }

              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            }, error => {
              $scope.noStoresFound = true;
            });
          };
          $scope.loadMore = () => {
            //  $uibModalInstance.close();
            if ($scope.count) {
              $scope.count = $scope.count + 5;
            } else {
              $scope.count = 10;
            }
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": $scope.count

            };
            if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
              data.showRedirectStores = true;
            }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              // console.log(success.data);
              // this.test();
              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            });
          };
          $scope.cancel = () => {

            $uibModalInstance.close();
          };
          $scope.selectStore = (index, store, item) => {
            $scope.showStoreInfo(item, index, store);
            $scope.selectedStore = item;
            $scope.storeObj = store;
            $scope.lat = store.lat;
            $scope.long = store.lng;
          };

          // InfoWindow fix for googlemap
          $scope.changeStyle = () => {
            if ($scope.notMoreThanone < 2) {
              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
              var selectorText = '.gm-style .gm-style-iw-c';
              var replace_infowindow = 'replace-infowindow';
              var arrow_selector = '.gm-style-iw-a::after';
              var replace_arrow_selector = 'replace_arrow_a::after';
              var theRules = [];
              for (var i = 0; i < document.styleSheets.length; i++) {
                try {
                  if (document.styleSheets[i].cssRules) {
                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText
                        || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow
                        || document.styleSheets[i].cssRules[j].selectorText == arrow_selector
                        || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
                        }
                      }
                    }
                  }
                } catch (e) {
                  // console.log("Some Error");
                }

              }
            } else {
              // console.log("Else part :");
            }
            $scope.notMoreThanone = $scope.notMoreThanone + 1;
          };

          $scope.goToProductPage = (store, item) => {
            $rootScope.selectedStoreId = store.id;
            $rootScope.$emit('storeSelected');
            $uibModalInstance.close();
          };
          $scope.goToSignUp = (store, item) => {
            $rootScope.selectedStoreId = store.id;
            $rootScope.selectedStore = item;
            $rootScope.$emit('storeSelected');
            // $ctrl.confirmChangeStore(store.id);
            // $uibModalInstance.close();
          };
        }
      ]

    });
  }

  openStoreSelector() {

    if (this.$auth.isLoggedIn()) {
      this.showLoginPopUp();
      return;
    }

    let msg = 'Text';
    var $ctrl;
    $ctrl = this;
    $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
    $ctrl.markerIcon = this.markerIcon;
    this.$uibModal.open({
      size: 'lg',
      template:
        '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' +
        '<div class="row">' +
        '<div class="col-md-3 p-l-0 p-r-0">' +
        '<div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div style="padding: 0;">' +
        '<form class="input-group" style="text-align: center;padding: 3px;">' +
        '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' +
        '<span class="input-group-btn"  >' +
        '<button type="submit"   ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' +
        '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' +
        '</button>' +
        '</span>' +
        '</form>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<br/><div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' +
        ' <div id="searchResults" ng-if="stores.length > 0" style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore(store, $index)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' +
        '<div  class="row store-nm-div">' +
        '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' +
        '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' +
        '</div> ' +
        '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' +
        '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' +
        '<span  class="search-span">Shop Now</span>' +
        '</button>' +
        '</div>' +
        '</div>' +

        '</div> </div>' +
        '<div class="col-md-12 p-r-0 p-l-0 closest-div">' +
        '<div class="col-md-12 p-r-0 p-l-0">' +
        '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' +
        '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' +

        '</div>' +
        '</div>' +
        '</div>' +


        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' +
        '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' +
        '<info-window id="storeInfo" max-width="200">' +
        '<div ng-non-bindable="">' +
        '<div class="scrollFix">' +
        '<div class="row">' +
        '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}' +
        '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' +
        '</div>' +
        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
        //  '<div class="col-xs-12">'+
        //    '<div class="m-b-0">'+
        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
        //    '<span>{{storeObj.addressLine1}}<br />'+
        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
        //    '</div>'+
        //  '</div>'+
        '</div>' +
        '</div>' +
        '</div>' +
        '</info-window>' +
        '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' +
        '</map>' +
        '</div>',
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap',
        function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
          this.$state = $state;

          $scope.selectedStoreClass = "selectedStore";
          $scope.notSelectedClass = "";
          $scope.noStoresFound = false;
          $scope.stores = [];
          $scope.lat = '37.274053';
          $scope.long = '-103.535156';
          $scope.zoom = 4;
          $scope.count = 5;
          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
          $scope.markerIcon = $ctrl.markerIcon;
          $scope.notMoreThanone = 0;

          NgMap.getMap()
            .then(map => {
              // console.log('map', map);
              $scope.map = map;
            });
          $scope.showStoreInfo = (e, index, storeObj) => {
            $scope.changeStyle();
            $scope.selectedStore = storeObj.storeURLName;
            $scope.storeIndex = index + 1;
            // console.log('storeObj', storeObj);
            $scope.storeObj = storeObj;
            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
          };
          $scope.formatMobileNum = (num, format) => {

            var unFormattedNum = num;
            var position1 = 0;
            var position2 = 4;
            var position3 = 9;
            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
            return FormattedNum;
          };
          $scope.ok = () => {
            //  $uibModalInstance.close();
            $scope.count = 5;
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": 5
            };
            if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
              data.showRedirectStores = true;
            }
            
            $scope.stores = [];
            let stores = $auth.getStoresbyZipcode(data);

            stores.then(success => {
              $scope.stores = success.data;
              $scope.lat = $scope.stores[0].lat;
              $scope.long = $scope.stores[0].lng;
              $scope.zoom = 4;
              $scope.noStoresFound = false;
              // console.log(success.data);
              if ($scope.stores.length == 0) {
                $scope.noStoresFound = true;
              }

              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            }, error => {
              $scope.noStoresFound = true;
            });
          };
          $scope.loadMore = () => {
            //  $uibModalInstance.close();
            if ($scope.count) {
              $scope.count = $scope.count + 5;
            } else {
              $scope.count = 10;
            }
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": $scope.count

            };
            if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
              data.showRedirectStores = true;
            }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              //  console.log(success.data);
              var elmnt = document.getElementById("searchResults");
              elmnt.scrollTo(0, 0);
              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            });
          };
          $scope.cancel = () => {

            $uibModalInstance.close();
          };
          $scope.selectStore = (store, index) => {
            var item = store.storeURLName;
            $scope.showStoreInfo(item, index, store);
            $scope.selectedStore = item;
            $scope.storeObj = store;
            $scope.lat = store.lat;
            $scope.selectedIndex = index + 1;
            $scope.long = store.lng;
          };

          // InfoWindow fix for googlemap
          $scope.changeStyle = () => {
            if ($scope.notMoreThanone < 2) {
              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
              var selectorText = '.gm-style .gm-style-iw-c';
              var replace_infowindow = 'replace-infowindow';
              var arrow_selector = '.gm-style-iw-a::after';
              var replace_arrow_selector = 'replace_arrow_a::after';
              var theRules = [];
              for (var i = 0; i < document.styleSheets.length; i++) {
                try {
                  if (document.styleSheets[i].cssRules) {
                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText
                        || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow
                        || document.styleSheets[i].cssRules[j].selectorText == arrow_selector
                        || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
                        }
                      }
                    }
                  }
                } catch (e) {
                  // console.log("Some Error");
                }

              }
            } else {
              // console.log("Else part :");
            }
            $scope.notMoreThanone = $scope.notMoreThanone + 1;
          };


          $scope.goToSignUp = (store, item) => {
            // console.log($stateParams);
            $stateParams.storeName = item;
            $window.location.href = '/' + $stateParams.storeName + '/' +
              $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
            // $uibModalInstance.close();
            //  this.$state.go('signup', {
            //    storeName: item
            //  });
          };
        }
      ]

    });
  }

  goToSubCategory(selectedItem) {
    var item = selectedItem.masterProduct;
    if (item && item != {}) {
      let storeName = '';
      if (this.$stateParams.storeName) {
        storeName = this.$stateParams.storeName;
      }
      else {
        if (this.profile.store && this.profile.store.storeName) {
          storeName = this.profile.store.storeURLName;
        } else {
          storeName = this.$auth.getGuestStoreDetail().storeName;
        }
      }
      // let storeName =  false;
      if (storeName) {
        if (item.category.name === item.subCategories[0].name) {
          this.$state.go('product', {
            categoryId: item.category.prettyUrl,
            subCategoryId: item.subCategories[0].prettyUrl,
            storeName: storeName
          });
        }
        else {
          // this.$state.go('sub-category', { categoryId: item.category.prettyUrl, storeName: storeName });
        this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl });
        }
      }
      else {
        this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl });
      }
    } else {
      this.$state.go('home');
    }
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  isMobileDevice() {
    return this.$auth.isMobileDevice();
  }

  goToGiftPage(store) {
    this.$state.go('gift-card', { 'storeName': store });
  }
  isGiftCard(masterProduct) {
    var seriesNumber = masterProduct.masterCode.charAt(0);
    var categoryId = masterProduct.category.id;
    return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
  }

  goToProductPage(item) {

    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (this.isGiftCard(item.masterProduct)) {
      this.goToGiftPage(storeName);
      return;
    }
    // let storeName =  false;
    if (storeName) {
      this.$state.go('browse-product.detail', {
        categoryId: item.masterProduct.category.prettyUrl,
        subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
        productId: item.masterProduct.prettyUrl,
        itemGroupNumber: item.masterProduct.itemGroupNumber,
        storeName: storeName
      });
    }
    else {
      this.$state.go('browse-product.detail', {
        categoryId: item.masterProduct.category.prettyUrl,
        subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
        productId: item.masterProduct.prettyUrl,
        itemGroupNumber: item.masterProduct.itemGroupNumber
      });
    }
  }

  isIpad() {
    return (this.$window.innerWidth < 1248 && this.$window.innerWidth > 767);
  }
  isNotMobile() {
    return (this.$window.innerWidth > 767);
  }
  isIpadLandscape() {
    if (this.isIpad()) {
      return (this.$window.innerWidth > 1037);
    } else {
      return false;
    }
  }
  deliveryTypeValidation() {
    const existingItem = this.$auth.isGuestLogin() ? this.$auth.getGuestCart() : ((this.cartDetail && this.cartDetail.cartItems) ? this.cartDetail.cartItems : []);
    if (existingItem && existingItem.length && this.selectedItem.deliveryType && this.selectedItem.deliveryType != 'All') {
      let itemExist = existingItem.filter(element => element.deliveryType == (this.selectedItem.deliveryType === 'InStore' ? 'DropShip' : 'InStore'));
      if (!this.$auth.isGuestLogin()) {
        itemExist = existingItem.filter(element => element.item.deliveryType == (this.selectedItem.deliveryType === 'InStore' ? 'DropShip' : 'InStore'));
      }
      if (itemExist && itemExist.length) {
        this.disableAddToCart = false;
        this.isDeliveryError = 'Your cart contains some items that are ' + (this.selectedItem.deliveryType === 'InStore' ? 'delivery' : 'in-store/curbside pickup') + ' only. If you would like to add this item to your cart, please remove those items or complete a separate order.';
        return false;
      }
    }
    return true;
  }
  
  goToCart() {
    if (this.$auth.isGuestLogin()) {
      this.$state.go('guestcart', {'storeName': this.storeName});
    } else {
      this.$state.go('cart');
    }
  }
  
  getMultipleImage (masterproduct) {
    this.$spinner.show('appSpinner');
    console.log('item.masterProduct.id', masterproduct.id);
    this.imageListArr[masterproduct.id] = [];
    this.$order.getMultipleImage(masterproduct.id)
    .then(success => {
      this.imageListArr[masterproduct.id] = success.data;
      console.log('imageList :', this.imageListArr);
      console.log('this.selectedItem :', this.selectedItem);
      this.imageListArr[masterproduct.id].forEach(item => {
        if(item.masterCode === this.selectedItem.masterProduct.masterCode){
          this.showImagelist(masterproduct.id);
        } else {
          this.$spinner.hide('appSpinner');
        }
      });
    });
  }
  showImagelist(id) {
    this.imageList = [];
    this.videoList = [];
    this.mediaListSize = 0;
    this.imgVideoList = [];
    this.imgVideoIpadList = [];
    if(this.imageListArr[id].length > 0) {
      this.imageListArr[id].forEach(item => {
      this.mediaListSize = this.mediaListSize+1;
      if (item.fileType === 'IMAGE') {
        if (item.isDefault === 1) {
          this.imageList.unshift(item);
          this.imgVideoList.unshift(item);
          this.imgVideoIpadList.unshift(item);
        } else {
          this.imageList.push(item);
          this.imgVideoList.push(item);
          this.imgVideoIpadList.push(item);
        }
      }
      if (item.fileType === 'VEDIO') {
        if (item.isDefault === 1) {
          this.videoList.unshift(item);
          this.imgVideoList.unshift(item);
          this.imgVideoIpadList.unshift(item);
        } else {
          this.videoList.push(item);
          this.imgVideoList.push(item);
          this.imgVideoIpadList.push(item);
        }
      }
      });
      this.slideIndex = 1;
        setTimeout(() => {
          if(document.getElementById('dotimage')){
            document.getElementById('dotimage').classList.remove('hide');
          }
            this.showSlides(1);
            if(this.isIpad()) {
            this.showSlidesIpad(1);
            } 
        }, 200);
        this.$spinner.hide('appSpinner');
    }
  }
  showSlides(n) {
    var slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");
    // console.log('slides:', slides);
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    for (var i = 0; i < slides.length; i++) {
      // console.log('i:', i);
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    console.log('n:', n);
    if (slides[this.slideIndex-1]){
      slides[this.slideIndex-1].style.display = "contents";
    }
    if (dots[this.slideIndex-1]){
      dots[this.slideIndex-1].className += " active";
    } 
  }

  showSlidesIpad(n) {
    var slides = document.getElementsByClassName("mySlidesIpad");
    console.log('slides:', slides.length);
    if (n > slides.length) {
      this.slideIndexIpad = 1;
    }
    if (n < 1) {
      this.slideIndexIpad = slides.length;
    }
    for (var i = 0; i < slides.length; i++) {
      // console.log('i:', i);
      slides[i].style.display = "none";
    }
    console.log('n:', n);
    if (slides[this.slideIndexIpad-1]){
      slides[this.slideIndexIpad-1].style.display = "contents";
    } 
  }
  plusSlides(n) {
    for (var i=0; i<this.imgVideoList.length; i++) {
      if(document.getElementById("mobileVideo"+i)) {
        document.getElementById("mobileVideo"+i).pause();
        document.getElementById("mobileVideo"+i).currentTime = 0;
      }
      if(document.getElementById("ipadVideo"+i)) {
        document.getElementById("ipadVideo"+i).pause();
        document.getElementById("ipadVideo"+i).currentTime = 0;
      }
    }
    this.showSlides(this.slideIndex += n);
  }
  plusSlidesIpad(n) {
    for (var i=0; i<this.imgVideoIpadList.length; i++) {
      if(document.getElementById("ipadVideo"+i)) {
        document.getElementById("ipadVideo"+i).pause();
        document.getElementById("ipadVideo"+i).currentTime = 0;
      }
    }
    this.showSlidesIpad(this.slideIndexIpad += n);
  }

  currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }
  scrollToBottom (id)  {
    const element = document.getElementById(id);
    // console.log("element.scrollHeight",element.scrollHeight);
     
    if(this.mediaListSize>this.multiImageViewPortSlideSize && this.currentImagePosition<this.mediaListSize){
      if(this.currentImagePosition ===0){
        this.currentImagePosition = this.multiImageViewPortSlideSize+1;
      }else{
        this.currentImagePosition = this.currentImagePosition + 1; 
      }
      // 60 is height of image view show in multi image view port
      this.currentImagePositionHeight = this.currentImagePositionHeight+60;
    }
    // console.log("this.currentImagePositionHeight ",this.currentImagePositionHeight );
    element.scrollTop = this.currentImagePositionHeight;
 }
 
 scrollToTop (id) {
  const element = document.getElementById(id);
  // console.log("element",element);
  if(this.currentImagePosition>this.multiImageViewPortSlideSize) {
    this.currentImagePosition = this.currentImagePosition - 1; 
     // 60 is height of image view show in multi image view port
    this.currentImagePositionHeight = this.currentImagePositionHeight-60;
  }
  // console.log("this.currentImagePositionHeight ",this.currentImagePositionHeight );
  element.scrollTop = this.currentImagePositionHeight;
 }

 showImgPopup(img) {
  var modal = document.getElementById("myModal");
  modal.style.display = "block";
  console.log('this.selectedItem :', this.selectedItem);
  this.selectedImgZoom = img;
  this.isShowImage = false;
  this.isShowVideo = true;
  this.imageListArr.forEach(item => {
    item.forEach(data => {
      console.log('item :', item);
      if(data.masterCode ===  this.selectedImgZoom.masterCode && data.fileType === 'VEDIO'){
        this.showVideolistZoom(this.selectedItem.masterProduct.id);
      } else {
        this.$spinner.hide('appSpinner');
      }
    });
  });
 }

 showImagelistZoom(id) {
  this.imageListZoom = [];
  if(this.imageListArr[id].length > 0) {
    this.imageListArr[id].forEach(item => {
      if(item.fileType === 'IMAGE') {
        if (item.isDefault === 1) {
          this.imageListZoom.unshift(item);
        } else {
          this.imageListZoom.push(item);
        }
      }
    });
    this.slideIndexZoom = 1;
      setTimeout(() => {
        this.showSlidesZoom(1);
      }, 200);
      this.$spinner.hide('appSpinner');
  }
}
showVideolistZoom(id) {
  this.videoListZoom = [];
  if(this.imageListArr[id].length > 0) {
    this.imageListArr[id].forEach(item => {
      if (item.fileType === 'VEDIO') {
        if (item.isDefault === 1) {
          this.videoListZoom.unshift(item);
        } else {
          this.videoListZoom.push(item);
        }
      }
    });
    this.slideIndexZoom = 1;
      setTimeout(() => {
        this.showSlidesZoom(1);
      }, 200);
      this.$spinner.hide('appSpinner');
  }
}
showSlidesZoom(n) {
  var slides = document.getElementsByClassName("mySlides1");
  let dots = document.getElementsByClassName("dot1");
  console.log('slides:', slides);
  if (n > slides.length) {
    this.slideIndexZoom = 1;
  }
  if (n < 1) {
    this.slideIndexZoom = slides.length;
  }
  for (var i = 0; i < slides.length; i++) {
    // console.log('i:', i);
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  console.log('n:', n);
  if (slides[this.slideIndexZoom-1]){
    slides[this.slideIndexZoom-1].style.display = "contents";
  }
  if (dots[this.slideIndexZoom-1]){
    dots[this.slideIndexZoom-1].className += " active";
  } 
}
plusSlidesZoom(n) {
  this.showSlidesZoom(this.slideIndexZoom += n);
}
currentSlideZoom(n) {
  for (var i=0; i<this.videoListZoom.length; i++) {
    if((i != n-1 ) && document.getElementById("itemVideo"+i)) {
    document.getElementById("itemVideo"+i).pause();
    document.getElementById("itemVideo"+i).currentTime = 0;
    }
  }
  this.showSlidesZoom(this.slideIndexZoom = n);
}
 closepopup(){
  var modal = document.getElementById("myModal");
  for (var i=0; i<this.videoListZoom.length; i++) {
    if(document.getElementById("itemVideo"+i)) {
      document.getElementById("itemVideo"+i).pause();
      document.getElementById("itemVideo"+i).currentTime = 0;
    }
  }
  modal.style.display = "none";
 }
 showImage() {
  this.isShowImage = true;
  this.isShowVideo = false;
  this.imageListArr.forEach(item => {
    item.forEach(data => {
      console.log('item :', item);
      if(data.masterCode ===  this.selectedImgZoom.masterCode){
        this.showImagelistZoom(this.selectedItem.masterProduct.id);
      } else {
        this.$spinner.hide('appSpinner');
      }
    });
  });
 }
 showVideo() {
  this.isShowImage = false;
  this.isShowVideo = true;
  this.imageListArr.forEach(item => {
    item.forEach(data => {
      console.log('item :', item);
      if(data.masterCode ===  this.selectedImgZoom.masterCode && data.fileType === 'VEDIO'){
        this.showVideolistZoom(this.selectedItem.masterProduct.id);
      } else {
        this.$spinner.hide('appSpinner');
      }
    });
  });
 }
 showHideDescription() {
  this.showDescription = !this.showDescription;
  this.showSpecifications = false;
  this.showWarranty = false;
  this.showMaterials = false;
  this.showIngredients = false;
 }
 showHideIngredients() {
  this.showIngredients = !this.showIngredients;
  this.showDescription = false;
  this.showSpecifications = false;
  this.showWarranty = false;
  this.showMaterials = false;
 }
 showHideSpecifications() {
  this.showSpecifications = !this.showSpecifications;
  this.showDescription = false;
  this.showWarranty = false;
  this.showMaterials = false;
  this.showIngredients = false;
 }
 showHideWarranty() {
  this.showWarranty = !this.showWarranty;
  this.showDescription = false;
  this.showSpecifications = false;
  this.showMaterials = false;
  this.showIngredients = false;
 }
 showHideMaterials() {
  this.showMaterials = !this.showMaterials;
  this.showDescription = false;
  this.showSpecifications = false;
  this.showWarranty = false;
  this.showIngredients = false;
 }

 showAddtoCartpopup() {
  this.isAddToCartPopUpShown = true;
  var modal = document.getElementById("addtocartModal");
  modal.style.display = "block";
 }

 closeAddtoCartpopup(){
  this.isAddToCartPopUpShown = false;
  var modal = document.getElementById("addtocartModal");
  modal.style.display = "none";
 }
 showAddtoCartMobilepopup() {
  var modal = document.getElementById("addtocartMobileModal");
  modal.style.display = "block";
 }

 closeAddtoCartMobilepopup(){
  var modal = document.getElementById("addtocartMobileModal");
  modal.style.display = "none";
 }

 updateItemInCart(quantityAction, quantity, item) {

    var ctrl = this;
    ctrl.itemToBePassed = item;
    // For Guest : Adding / Removing Items in guest cart
    if (this.$auth.isGuestLogin()) {
      const cartList = ctrl.$auth.getGuestCart();
      if (cartList && cartList.length) {
        let index = cartList.findIndex(data => data.itemId === item.id);
        if (~index) {
          if(quantityAction == ctrl.quantityAction.AddingQuantity) {
            ctrl.quantityToBeAdded = cartList[index].quantity + 1;
          } else if(quantityAction == ctrl.quantityAction.ReducingQuantity) {
            ctrl.quantityToBeAdded = cartList[index].quantity - 1;
          }
          cartList[index].quantity = ctrl.quantityToBeAdded;
        } else {
          // cartList.push(cart);
          console.log("Check what's need to be done in here");
        }
      }
      ctrl.$auth.updatetoGuestCart(cartList);
    } else {
      // For Logged in user : Adding / Removing Items in guest cart
      if(quantityAction == ctrl.quantityAction.AddingQuantity) {
        ctrl.quantityToBeAdded = quantity+1;
      } else if(quantityAction == ctrl.quantityAction.ReducingQuantity) {
        ctrl.quantityToBeAdded = quantity-1;
      }
      ctrl.$order.updateItemInCart(ctrl.quantityToBeAdded, item.id, item.masterProduct.subCategories[0].id)
        .then(
          () => {
            ctrl.isItemAdded = true;
            ctrl.$auth.getUserProfile();
          },
          error => {
            // If no item in cart (error code = 637), then add item to cart
            if(error.data.errorCode==637){
              if (ctrl.$auth.isGuestLogin()) {
                let cart = null;
                cart = {
                  'quantity': ctrl.quantity,
                  'itemId': ctrl.selectedItem.id,
                  'categoryId': ctrl.selectedItem.masterProduct.category.id,
                  'subCategoryId': ctrl.selectedItem.masterProduct.subCategories[0].id,
                  'masterProductId': ctrl.selectedItem.masterProduct.id,
                  'deliveryType': ctrl.selectedItem.deliveryType
                };
                ctrl.$auth.addtoGuestCart(cart);
              } else {
                var item;
                item = {
                  'itemId': ctrl.selectedItem.id,
                  'subCategoryId': ctrl.selectedItem.masterProduct.subCategories[0].id
                };
                ctrl.addToCart(ctrl.quantity, item);
              }
            }
            else if (error.data.errorCode == 692) {
              ctrl.toaster.pop('success', error.data.message);
            }
            else {
              ctrl.toaster.pop('success', 'Item already exists in cart. Click on cart icon on top right.');
            }
          }
        );
        this.$auth.getUserProfile();
    }
  }

  getDSCDetails(isDscMember) {
    this.$order.getDSCDetails().then(success => {
      if (success.data) {
        this.dscDetails = success.data.filter(element => element.dscType == 'dsc')[0];
        this.nondscDetails = success.data.filter(element => element.dscType == 'nondsc')[0];
        if(isDscMember){
          
          if(this.dscDetails) {
            this.dscCard = this.dscDetails.dscImage;
            this.dscCardMobile = this.dscDetails.dscImageMobile;
            this.dscAltTag = this.dscDetails.alt;
          } else {
            this.dscCard = this.dscCardDefault;
            this.dscCardMobile = this.dscCardMobileDefault;
          }
        } else {
          if(this.nondscDetails) {
            this.dscCard = this.nondscDetails.dscImage;
            this.dscCardMobile = this.nondscDetails.dscImageMobile;
            this.dscAltTag = this.nondscDetails.alt;
            this.dscLink = this.nondscDetails.link;
          } else {
            this.dscCard = this.dscCardDefault;
            this.dscCardMobile = this.dscCardMobileDefault;
          }
        }
        console.log(this.dscDetails);
        console.log(this.nondscDetails);
      }
      });
  }
  
  getDSCImage(isMobileDevice){
    if(this.isDscMember()){
      if(isMobileDevice){
        if(this.NonDSCImgMobile){
          return this.NonDSCImgMobile;
        } else {
          return dscCardMobileDefault;
        }
      } else {
        if(this.NonDSCImgDesktop) {
          return this.NonDSCImgDesktop;
        } else {
          return dscCardDefault;
        }
      }
    } else {
      if(isMobileDevice){
        if(this.DSCImgMobile){
          return this.DSCImgMobile;
        }else {
          return dscCardMobileDefault;
        }
      } else {
        if(this.DSCImgDesktop){
          return this.DSCImgDesktop;
        } else {
          return dscCardDefault;
        }
      }
    }
  }

  setDimension(selectedItem){
    let customSpec = "";
    if(selectedItem && selectedItem.masterProduct.dimensions){
      customSpec = "Dimensions : "+selectedItem.masterProduct.dimensions;
      if(selectedItem.masterProduct.specifications) {
        customSpec = customSpec + "<br>" + selectedItem.masterProduct.specifications;
      }
    } else {
      if(selectedItem.masterProduct.specifications) {
        customSpec = selectedItem.masterProduct.specifications;
      }
    }
    this.customSpecification = customSpec;
    return selectedItem;
  }

  goToDsc() {
    if(!this.isDscMember()){
      if(this.dscLink) {
        this.$window.location.href = this.dscLink;
      } else {
        this.$state.go('savings-club');
      }
    } else {
      // this.$window.location.href = this.dscLink;
    }
  }

  updateUserAction(userAction){
    this.$order.updateUserAction(userAction);
  }

  saveRemainder(remainderType) {
    var $ctrl = this;
    let remainder = {};
    remainder.email = this.emailToRemainder;
    remainder.isRemainded = false;
    remainder.masterProduct = this.selectedItem.masterProduct;
    remainder.store = {};
    remainder.store.storeCode = this.selectedItem.store.storeCode;
    remainder.type = remainderType;
    remainder.isGuest = (this.profile==null || this.profile.userId==null)? true : false;
    this.$order.saveRemainder(remainderType,remainder).then(success => {
        if (success.data) {
          this.isRemainderSetAlready = true; 
          if(success.data && success.data.isAddedAlready){
            this.outOfStockRemainderText = this.OutOfStockRemainderText.exist;
          } else {
            this.outOfStockRemainderText = this.OutOfStockRemainderText.new;
          }
          // let outOfStockRemainders = sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS') ? JSON.parse(sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS')) : null;
          let outOfStockRemainders = sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS') ? JSON.parse(sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS')) : null;
          if(outOfStockRemainders!=null) {
            outOfStockRemainders[$ctrl.selectedItem.id] = $ctrl.emailToRemainder;
            sessionStorage.setItem('OUT_OF_STOCK_REMAINDERS', JSON.stringify(outOfStockRemainders));
          } else {
            outOfStockRemainders = {};
            outOfStockRemainders[$ctrl.selectedItem.id] = $ctrl.emailToRemainder;
            sessionStorage.setItem('OUT_OF_STOCK_REMAINDERS', JSON.stringify(outOfStockRemainders));
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/order/product/detail.js